// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "1b041c9c" : chunkId) + "." + {"45":"f67b986d467ef26e","154":"42e77adc72f03937","362":"db8fe4062a17ab43","480":"ce5857396f7f91f5","701":"7e24c7074b006754"}[chunkId] + ".js";
};